import React, { useState,useEffect } from "react";
import "../../components/SupplierList/SupplierList.css";
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MailIcon from "@mui/icons-material/Mail";
import SendIcon from '@mui/icons-material/Send';
import axios from "axios";
import AddVendorDetails_Admin from "../AddVendorDetails_Admin/AddVendorDetails_Admin";
import SearchIcon from "@mui/icons-material/Search";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const baseAPI = process.env.REACT_APP_API_URL;

const SupplierList = ({
  supplierDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  openAddProfile,
  setOpenAddProfile,
}) => {
  const [formData, setFormData] = useState({});
  const [mailSent, setMailSent] = useState([]);
  const[vendorCategory,setVendorCategory]=useState([])
  const[vendorSupplySource,setVendorSupplySource]=useState([])
  const [disabledButtons, setDisabledButtons] = useState([]);

  useEffect(() => {
    GetVendorCategory()
    getCurrentVendorCategory()
    GetVendorSupplySurce()
  
}, []);

function GetVendorCategory(){
  const storedToken = JSON.parse(localStorage.getItem("token"));

  if (storedToken) {
    axios
      .get(`${baseAPI}AdminGet/GetVendorCategory`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {       
        setVendorCategory(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }
}

function getCurrentVendorCategory(categoryId) {
  if(categoryId!==null || categoryId!== undefined){
      const category = vendorCategory.find((cat) => 
    cat.Tseed == categoryId);
  if(category!==undefined){
  return category.Category_Name
  }
}
  
}

function GetVendorSupplySurce(){
  const storedToken = JSON.parse(localStorage.getItem("token"));

  if (storedToken) {
    axios
      .get(`${baseAPI}AdminGet/GETVendorSupplySourceDetails`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {        
        setVendorSupplySource(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }
}

function getCurrentVendorSupplySource(Id) {
  if(Id!==null ||Id!== undefined){
      const supplySource = vendorSupplySource.find((source) => 
    source.Tseed ==Id);
  if(supplySource!==undefined){
  return supplySource.State_Name
  }
}
  
}

  const sendMail = async (email, guid,index) => {
    setMailSent([...mailSent, index]);
    setDisabledButtons([...disabledButtons, index]); 
    const VendorEmailObj = { VendorEmail: email,VendorGUID:guid };
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}Adminpost/SendVendorMail`,
        VendorEmailObj,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }

      );
      toast.success("Mail has been sent to the vendor", {
        position: "top-right",
        autoClose: 2000, 
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  function nextPage(VendorGUID){   
    // const url = `/AddVendorDetails_Admin?vendorID=${VendorGUID}`;
    const url = `/vendorDetailOverview?vendorID=${VendorGUID}`;
    window.open(url, '_self');
  }

  return (
    <div  className="container-fluid">
      <div className="supplierList">
        <table style={{width:"100%"}}  className="table_supplier">
          <thead>
            <tr className="supplierListHeading">
              <th>S.No.</th>
              <th>Name</th>
              <th>Display Name</th>
              <th>Company Name</th>
              <th>Vendor Email</th>
              <th>Category</th>
              <th>Work Phone</th>
              <th>Supply Source</th>
              <th>Payables</th>
              <th>Unused Credits</th>
              <th>Send Mail</th>
              <th>Action</th>
            </tr>     
          </thead>
          <tbody>
            {supplierDetailResponse !== null ? (
              supplierDetailResponse.map((supplier, index) => (

                <tr key={supplier.Supplier_ID}>
                  <td>{supplier.Vendor_Id}</td>
                  <td>{supplier.VendorFirstName}{" "}{supplier.VendorLastName}</td>
                  <td>{supplier.DisplayName}</td>
                  <td>{supplier.CompanyName}</td>
                  <td>{supplier.VendorEmail}</td>
                  <td>{getCurrentVendorCategory(supplier.VendorCategory)}</td>
                  <td>{supplier.Phone1}</td>
                  <td>{getCurrentVendorSupplySource(supplier.SupplySource)}</td>
                  <td>{supplier.Payables}</td>
                  <td>{supplier.Unused_Credits}</td>
                  <td >
                    <button
                  disabled={
                    disabledButtons.includes(index) || supplier.MailSent ?true
                    :false
                  }
                  className={`icon ${
                   mailSent.includes(index) || supplier.MailSent ? "supplier_list_mail_green_new" : "supplier_list_mail_grey_new"
                  }`}         
                            onClick={() => sendMail(supplier.VendorEmail, supplier.VendorGUID,index)}
                    >
                      <SendIcon style={{height:"28px",width:"39px",marginLeft: "-3px", marginTop: "1px"}} className="icon" />
                                          <ToastContainer/>
                    </button>
                  </td>
                  <td style={{textAlign:"center"}} >
    <button className="text-center" style={{border: "none",
    width: "37px",
    padding: "0px",
    height: "36px",
    backgroundColor: "#F1F1F1", color: "#6a6a6a", border: "none",  }} onClick={() => nextPage(supplier.VendorGUID)} >
    
     {/* href={`http://localhost:3000/AddVendorDetails_Admin?vendorID=${supplier.VendorGUID}`} */}
    
      <SearchIcon />
    </button>
   

</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15">No suppliers available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SupplierList;
